import { invert } from 'lodash';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import { getSensitivity, saveSensitivityDataForMetric } from '@src/api/aiAlerts';
import { trackQueryError } from '@src/utils/sensor/apptracker';

const SENSITIVITY_METRIC_MAP = {
  // key is the metrics defined in the IF client
  // value is the metrics stored in the portal DB
  // ae stands for app
  ae: {
    APP_PAGE_LOAD_TIME: 'AIALERTPAGELOADTIME',
    APP_SCREEN_LOAD_TIME: 'AIALERTSCREENLOADTIME',
    APP_NETWORK_REQUEST_TIME: 'AIALERTNETWORKREQUESTTIME',
    APP_ACTIVE_DEVICES: 'AIALERTACTIVEDEVICES',
  },
  ei: {},
  ai: {},
};

function useFetchSensitivity() {
  const queryClient = useQueryClient();
  const { data, isFetching, isError, refetch } = useQuery(
    ['ai-alerts-sensitivity'],
    async () => await getSensitivity({}),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      onError: (err) => {
        trackQueryError({ type: 'ai-alerts-sensitivity-error', err });
      },
    },
  );

  const updateSensitivityMutation = useMutation(
    (data: any) => {
      const metricMap = SENSITIVITY_METRIC_MAP['ae'];
      const reformatMetricKeyForECO = data.map((item) => {
        if (item.app !== 'ae') return item;
        const metric = metricMap[item.metric] || item.metric;
        return { ...item, metric };
      });
      return saveSensitivityDataForMetric(reformatMetricKeyForECO);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('ai-alerts-sensitivity');
      },
    },
  );

  const metricData = (data?.data || []).map((item) => {
    // update metric add APP prefix
    const metricMap = SENSITIVITY_METRIC_MAP[item.app] || {};
    const invertedMap = invert(metricMap);
    item.metric = invertedMap[item.metric] || item.metric;
    return item;
  });

  return { data: metricData, isFetching, isError, refetch, updateSensitivityMutation };
}

export default useFetchSensitivity;
